export default "__VITE_ASSET__yMgk0lN6__"